module.exports = __webpack_public_path__ + "static/media/Wayne Stanley Headshot.9f462d8d.jpeg";